/** 
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Login API services
  Date: April 2020
**/

import API from '../utils/api';
import LocalStorageService from './localStorage';

const localStorageService = LocalStorageService.getService();

export const login = (postData) => {
  return API.post('/users/login', postData);
};

export const getUserInfo = () => {
  return API.get(`users/me`, {
    headers: {
      Authorization: `Bearer ${localStorageService.getAccessToken()}`,
    },
  });
};

export const resetPassword = (postData) => {
  return API.post('/users/users/resetpassword', postData);
};

export const forgotPassword = (postData) => {
  return API.post('/users/users/forgotpassword', postData);
};

export const changePassword = (postData) => {
  return API.put(`/users/users/password/${postData.username}`, postData, {
    headers: {
      Authorization: `Bearer ${localStorageService.getAccessToken()}`,
    },
  });
};


export const ssoLogin = (postData) => {
  return API.post(`/users/sso-login`, postData, {
    headers: {
      Authorization: `Bearer ${postData.access_token}`,
    },
  });
};

export const azureLogin = (postData) => {
  return API.post(`/users/get-token-by-code`, postData);
};
